module.exports = __webpack_public_path__ + "img/ico_arrowGroup.5d9a8b76.png";